import { environment } from "environments/environment";

export const helpWidgetConfig = {
  docs: {
    baseUrl: environment.helpWidgetUrl,
    defaultContext: 'documentation',
  },

  userback: {
    widgetSettings: {
      triggerType: 'page_load',
      position: 'e',
    }
  }
} as const;